import React, { useState } from "react"
import styled from "styled-components"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Hero from "../components/hero/Hero"
import HeroWildlife from "../components/hero/HeroWildlife"
import HeroLandscape from "../components/hero/HeroLandscape"
import HeroArchitecture from "../components/hero/HeroArchitecture"
import Footer from "../components/hero/Footer"
import ToTopButton from "../components/hero/ToTopButton"

const IndexPage = () => {
  const [showToTop, setShowToTop] = useState(false)

  const backToTop = () => {
    // window[`scrollTo`]({ top: 0, behavior: `smooth` })
    // Parallax.scrollTo({ top: 0, behavior: "smooth" })
    document.querySelector("#parallax").scrollTo({ top: 0, behavior: "smooth" })
  }

  // @keyframes buttonEntrance {
  //   from {
  //     opacity: 0;
  //     transform: translate3d(0, 100%, 0);
  //   }
  //   to {
  //     opacity: 1;
  //     transform: translate3d(0, 0, 0);
  //   }
  // }

  // @keyframes buttonExit {
  //   from {
  //     opacity: 1;
  //   }
  //   to {
  //     opacity: 0;
  //     transform: translate3d(0, 0, 0);
  //   }
  // }

  return (
    <Layout>
      <SEO title="Home" />
      <Wrapper>
        {/* <ToTopButton topClick={backToTop} /> */}
        {showToTop && <ToTopButton toTopClick={backToTop} />}
        <Parallax
          id="parallax"
          onScroll={e =>
            e.target.scrollTop > 1000 ? setShowToTop(true) : setShowToTop(false)
          }
        >
          <Hero />
          <HeroWildlife />
          <HeroLandscape />
          <HeroArchitecture />
          <Footer />
        </Parallax>
      </Wrapper>
    </Layout>
  )
}

export default IndexPage

const Wrapper = styled.div``

const Parallax = styled.div`
  overflow-x: hidden;
  height: 100vh;
  perspective: 1px;
  background-color: #1b262c;
  color: #fff;
  overflow-y: scroll;

  font-family: "julius sans one";

  &::-webkit-scrollbar {
    display: none;
  }
`
